import { Gizmo } from '../../gizmos';
import { IGizmoData } from '../../types';
import { gnov } from '../../utils';

interface IAccessMetadata {
  variable: string;
  data: IGizmoData;
  context: {
    answerGizmo?: Gizmo;
  };
}

/**
 * Access metadata from an IGizmoData object
 *
 * @param {string} variable variable we're trying to access
 * @param {IGizmoData} data gizmo's data
 *
 * @returns metadata value if found
 */
function accessMetadata({ variable, data, context }: IAccessMetadata): any {
  const [uid, ...accessor] = variable.split('.');
  const { answerGizmo } = context;

  const searchOptions = answerGizmo?.getConfig().ops?.search;

  if (
    uid &&
    accessor[0] &&
    accessor[0] === 'metadata' &&
    accessor[1] &&
    data &&
    data.v
  ) {
    const answers = gnov(data, 'sd.answers');

    if (answers) {
      // Right now we only support metadata access by fid
      let fid = accessor[1];

      // If the variable is an uid we're going to try go look for the metadata gizmos
      // and try to get the fid
      if (!accessor[1].match(/^\s*q_?\d*\s*/g) && searchOptions?.metadata) {
        const metadataGizmo = searchOptions.metadata.find(
          g => g.uid === accessor[1]
        );
        if (metadataGizmo) {
          fid = metadataGizmo.f_id;
        }
      }

      const value = answers[fid];

      if (value !== undefined && value[0] && value[0]['value'] !== undefined) {
        return value[0]['value'];
      }
    }
  } else if (uid && accessor[0] && accessor[0] === 'data' && data) {
    // When user specified .data it means they want the whole data object, not just the value (v)
    return data;
  }
}

export default accessMetadata;
